module.exports = __webpack_public_path__ + "static/media/icon-postgres.878bfec8.png";